module.exports = __webpack_public_path__ + "media/images/workplace/SVG/CW-Logo-dark-2b6788b48ade13f2df8e5e8bb324b20a.svg";